import { Edge } from "@xyflow/react";

import { DataAdapter } from "@/DataAdapter/DataAdapter";

import {
	DeleteEdgeRequest,
	DeleteNodeRequest,
	DiagramNodeRequest,
	DiagramNodeResponse,
	NodeDiagramPublicityResponse,
	TogglePublishNodeDiagramRequest,
	UpdateEdgeRequest,
	UpdateGroupRequest,
	UpdateNodeParent,
	UpdateNodePosition,
} from "@/model/NodeDiagram/types";

// NodeDigram Base API
export const fetchNodeDiagramPublicity = (id: number): Promise<NodeDiagramPublicityResponse> => {
    return DataAdapter.Get<NodeDiagramPublicityResponse>({ endpoint: `NodeDiagram/${id}`});
}

export const togglePublishNodeDiagram = (
	request: TogglePublishNodeDiagramRequest,
): Promise<number> => {
	return DataAdapter.Post<number>(`NodeDiagram/publish`, request);
};

// NodeDiagram Nodes API
export const fetchNodeDiagramNodes = (
	id: number,
): Promise<DiagramNodeResponse[]> => {
	return DataAdapter.Get<DiagramNodeResponse[]>({
		endpoint: `NodeDiagramNodes/${id}`,
	});
};

export const addSingleDiagramNode = (
	node: DiagramNodeRequest,
): Promise<DiagramNodeResponse> => {
	return DataAdapter.Post<DiagramNodeResponse>(`NodeDiagramNodes`, node);
};

export const addExistingNodeDiagramNodes = (
	nodes: DiagramNodeRequest[],
): Promise<DiagramNodeResponse[]> => {
    return DataAdapter.Post<DiagramNodeResponse[]>(
        `NodeDiagramNodes/existing`,
		nodes,
	);
};

export const updateNodePosition = (
    node: UpdateNodePosition,
): Promise<UpdateNodePosition> => {
    return DataAdapter.Patch<UpdateNodePosition>(`NodeDiagramNodes`, node);
};

export const updateNodeParent = (node: UpdateNodeParent): Promise<number> => {
    return DataAdapter.Patch<number>(`NodeDiagramNodes/parent`, node);
};

export const deleteNode = (
    request: DeleteNodeRequest,
): Promise<DeleteNodeRequest> => {
    return DataAdapter.Delete<DeleteNodeRequest>(
        `NodeDiagramNodes/${request.NodeId}`,
        request,
    );
};

// NodeDiagram Groups API
export const fetchNodeDiagramGroups = (
	id: number,
): Promise<DiagramNodeResponse[]> => {
	return DataAdapter.Get<DiagramNodeResponse[]>({
		endpoint: `NodeDiagramGroups/${id}`,
	});
};

export const addDiagramGroup = (
    node: DiagramNodeRequest,
): Promise<DiagramNodeResponse> => {
    return DataAdapter.Post<DiagramNodeResponse>(`NodeDiagramGroups`, node);
};

export const updateGroup = (
	group: UpdateGroupRequest,
): Promise<UpdateGroupRequest> => {
	return DataAdapter.Patch<UpdateGroupRequest>(`NodeDiagramGroups`, group);
};


export const deleteGroup = (
	request: DeleteNodeRequest,
): Promise<DeleteNodeRequest> => {
	return DataAdapter.Delete<DeleteNodeRequest>(
		`NodeDiagramGroups/${request.NodeId}`,
		request,
	);
};

// NodeDiagram Edges API
export const fetchNodeDiagramEdges = (id: number): Promise<Edge<any>[]> => {
	return DataAdapter.Get<Edge<any>[]>({
		endpoint: `NodeDiagramEdges/${id}`,
	});
};

export const addDiagramEdge = (
	edge: UpdateEdgeRequest,
): Promise<void> => {
	return DataAdapter.Post(`NodeDiagramEdges`, edge);
};

export const updateDiagramEdge = (
	edge: UpdateEdgeRequest,
): Promise<UpdateEdgeRequest> => {
	return DataAdapter.Patch<UpdateEdgeRequest>(`NodeDiagramEdges`, edge);
};

export const deleteDiagramEdge = (
	request: DeleteEdgeRequest,
): Promise<DeleteEdgeRequest> => {
	return DataAdapter.Delete<DeleteEdgeRequest>(
		`NodeDiagramEdges`,
		request,
	);
};

export const deleteAllDiagramEdges = (
	ProcedureId: number,
): Promise<number> => {
	return DataAdapter.Delete<number>(`NodeDiagramEdges/${ProcedureId}`, {});
}
